import React from "react";
import classNames from "classnames";
import { SVVNavCard2Props } from "./types";

export function SVVNavigationCard2({
  heading,
  url,
  ingress,
  large = false,
  ...restProps
}: SVVNavCard2Props) {
  const { asElement = "a", hrefAttribute = "href", headingLevel = "h3", ...rest } = restProps;
  const Element = asElement;
  const Head = headingLevel;
  return (
    <div
      className={classNames("svv-navigation-card svv-navigation-card--level2", {
        "svv-navigation-card svv-navigation-card--large": large,
      })}
    >
      <div className="svv-navigation-card__title-container">
        <Element
          {...(url && { [hrefAttribute]: url })}
          {...rest}
          className="svv-navigation-card__link"
        >
          <Head className="svv-navigation-card__title">{heading}</Head>
        </Element>
      </div>
      {ingress && (
        <div className="svv-navigation-card__text-container">
          <p>{ingress}</p>
        </div>
      )}
    </div>
  );
}

SVVNavigationCard2.displayName = "SVVNavigationCard2";
